export default __webpack_public_path__ + "static/media/roadmap1.10691f71.png";